(() => {
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */ (function($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var mirai = {
        // All pages
        common: {
            init: function() {
                // Hide Sub Menu when clicking outside
                $(document).click(function(e) {
                    if (document.documentElement.clientWidth > 900) {
                        e.stopPropagation();
                        var container = $('.nav-primary');
                        //check if the clicked area is dropDown or not
                        if (container.has(e.target).length === 0) $('.nav-primary li, .sub-menu').removeClass('menu-active');
                    }
                });
                // Smooth scroll to links
                $('a[href*="#"]:not([href="#"])').click(function() {
                    var offset = -80; // <-- change the value here
                    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html, body').animate({
                                scrollTop: target.offset().top + offset
                            }, 1000);
                            return false;
                        }
                    }
                });
                // Header Shrink
                var headerHeightShrink = $('.header').height();
                $(window).scroll(function(event) {
                    var scroll = $(window).scrollTop();
                    if (scroll > headerHeightShrink) {
                        $('body').addClass('header-shrink');
                        $('header').addClass('shrink');
                    } else {
                        $('body').removeClass('header-shrink');
                        $('header').removeClass('shrink');
                    }
                });
                // wrap embeds in div
                $('iframe[src^="https://www.youtube.com/embed/"]').wrap('<div class="embed"></div>');
                $('iframe[src^="https://player.vimeo.com/video"]').wrap('<div class="embed"></div>');
                // Submenu Functionality
                $('.nav-primary > li').click(function() {
                    var $this = $(this), $ul = $('> ul', this);
                    if (!$ul.hasClass('menu-active')) {
                        // Add class to current list item
                        $this.addClass('menu-active');
                        // Slide down used for mobiles
                        $ul.toggleClass('menu-active').slideDown();
                    } else {
                        $this.removeClass('menu-active');
                        $ul.removeClass('menu-active');
                    }
                });
                $(".search-mobile").click(function() {
                    if ($(this).hasClass('open')) $(this).removeClass('open');
                    else $(this).addClass('open');
                });
                // Mobile Trigger to open Mobile Menu
                $('.mobile-trigger').click(function() {
                    $(this).find('span').toggleClass('mobile-menu-active');
                    $('body, .nav-mobile').toggleClass('mobile-menu-active');
                });
                // Mobile Menu Submenu
                $('.offcanvas nav ul li').click(function() {
                    if ($(this).hasClass('open')) $(this).removeClass('open');
                    else {
                        $('.offcanvas nav ul li').removeClass('open');
                        $(this).addClass('open');
                    }
                });
                $('.offcanvas nav ul li a').click(function(event) {
                    event.stopPropagation();
                });
                // Scroll Down Arrow Functionality
                $('.scroll-down-arrow').click(function() {
                    var distance = $(this).closest('.block').outerHeight();
                    $("html, body").animate({
                        scrollTop: distance + "px"
                    });
                });
                // Float Container
                function updateFloatContainers() {
                    if (!$('body').hasClass('page-template-page-course')) {
                        var windowWidth = $(document).width();
                        // If Container larger than 1400
                        if (windowWidth >= 1400) {
                            var allowedWidth = windowWidth / 10 * 9;
                            if (allowedWidth >= 1400) {
                                var remainingWidth = windowWidth - 1400;
                                var marginFloat = remainingWidth / 2;
                                $('.float-container-left').css('padding-left', marginFloat);
                                $('.float-container-right').css('padding-right', marginFloat);
                            } else {
                                var remainingWidth = windowWidth - allowedWidth;
                                var halfRemainingWidth = remainingWidth / 2;
                                $('.float-container-left').css('padding-left', halfRemainingWidth);
                                $('.float-container-right').css('padding-right', halfRemainingWidth);
                            }
                        } else if (windowWidth < 1400 && windowWidth >= 1100) {
                            var allowedWidth = windowWidth / 10 * 9;
                            var remainingWidth = windowWidth - allowedWidth;
                            var halfRemainingWidth = remainingWidth / 2;
                            $('.float-container-left').css('padding-left', halfRemainingWidth);
                            $('.float-container-right').css('padding-right', halfRemainingWidth);
                        } else if (windowWidth < 1100 && windowWidth >= 1000) {
                            var allowedWidth = windowWidth / 10 * 9;
                            var remainingWidth = windowWidth - allowedWidth;
                            var halfRemainingWidth = remainingWidth / 2;
                            $('.float-container-left').css('padding-left', halfRemainingWidth);
                            $('.float-container-right').css('padding-right', halfRemainingWidth);
                            // Remove from containers that no longer float
                            $('.float-container-left.block__image-text--simple').css('padding-left', 0);
                            $('.float-container-right.block__image-text--simple').css('padding-right', 0);
                            $('.float-container-left.hero__standard').css('padding-left', 0);
                            $('.float-container-right.hero__standard').css('padding-right', 0);
                            $('.float-container-left.hero__standard-dual').css('padding-left', 0);
                            $('.float-container-right.hero__standard-dual').css('padding-right', 0);
                            $('.float-container-left.hero__standard-single-50').css('padding-left', 0);
                            $('.float-container-right.hero__standard-single-50').css('padding-right', 0);
                            $('.float-container-left.block__content-slider').css('padding-left', 0);
                            $('.float-container-right.block__content-slider').css('padding-right', 0);
                            $('.float-container-left.block__contact').css('padding-left', 0);
                            $('.float-container-right.block__contact').css('padding-right', 0);
                        } else if (windowWidth < 1000 && windowWidth >= 768) {
                            var allowedWidth = windowWidth / 10 * 9;
                            var remainingWidth = windowWidth - allowedWidth;
                            var halfRemainingWidth = remainingWidth / 2;
                            $('.float-container-left').css('padding-left', halfRemainingWidth);
                            $('.float-container-right').css('padding-right', halfRemainingWidth);
                            // Remove from containers that no longer float
                            $('.float-container-left.block__image-text--simple').css('padding-left', 0);
                            $('.float-container-right.block__image-text--simple').css('padding-right', 0);
                            $('.float-container-left.block__image-text--grid').css('padding-left', 0);
                            $('.float-container-right.block__image-text--grid').css('padding-right', 0);
                            $('.float-container-left.hero__standard').css('padding-left', 0);
                            $('.float-container-right.hero__standard').css('padding-right', 0);
                            $('.float-container-left.hero__standard-dual').css('padding-left', 0);
                            $('.float-container-right.hero__standard-dual').css('padding-right', 0);
                            $('.float-container-left.hero__standard-single-50').css('padding-left', 0);
                            $('.float-container-right.hero__standard-single-50').css('padding-right', 0);
                            $('.float-container-left.block__content-slider').css('padding-left', 0);
                            $('.float-container-right.block__content-slider').css('padding-right', 0);
                            $('.float-container-left.block__contact').css('padding-left', 0);
                            $('.float-container-right.block__contact').css('padding-right', 0);
                        } else {
                            // Remove from all as we're now on mobile 
                            $('.float-container-left').css('padding-left', 0);
                            $('.float-container-right').css('padding-right', 0);
                        }
                    }
                }
                // Update Card Headings
                function updateCardHeadings() {
                    var cards = $('.card');
                    var windowWidth = $(document).width();
                    if (windowWidth >= 768) $.each(cards, function(index, element) {
                        if ($(element).hasClass('card--even')) {
                            // Find Next 'Odd' card down
                            var nextCard = $(element).next('.card--odd');
                            // Reset any inline CSS
                            $(nextCard[0]).find('h3').css("height", '');
                            $(nextCard[0]).find('.card__content').css("height", '');
                            $(nextCard[0]).find('.card__links').css("height", '');
                            $(element).find('h3').css("height", '');
                            $(element).find('.card__content').css("height", '');
                            $(element).find('.card__links').css("height", '');
                            // Get Even Card
                            var cardHeading = $(element).find('h3');
                            var cardContent = $(element).find('.card__content');
                            var cardLinks = $(element).find('.card__links');
                            // Get Even Card Height
                            var cardHeadingHeight = cardHeading.outerHeight();
                            var cardContentHeight = cardContent.outerHeight();
                            var cardLinksHeight = cardLinks.outerHeight();
                            // Get Odd Card
                            var nextCardHeading = $(nextCard[0]).find('h3');
                            var nextCardContent = $(nextCard[0]).find('.card__content');
                            var nextCardLinks = $(nextCard[0]).find('.card__links');
                            // Get Odd Card Height
                            var nextCardHeadingHeight = nextCardHeading.outerHeight();
                            var nextCardContentHeight = nextCardContent.outerHeight();
                            var nextCardLinksHeight = nextCardLinks.outerHeight();
                            // Compare Heights
                            if (cardHeadingHeight > nextCardHeadingHeight) $(nextCard[0]).find('h3').css("height", cardHeadingHeight);
                            else $(element).find('h3').css("height", nextCardHeadingHeight);
                            if (cardContentHeight > nextCardContentHeight) $(nextCard[0]).find('.card__content').css("height", cardContentHeight);
                            else $(element).find('.card__content').css("height", nextCardContentHeight);
                            if (cardLinksHeight > nextCardLinksHeight) $(nextCard[0]).find('.card__links').css("height", cardLinksHeight);
                            else $(element).find('.card__links').css("height", nextCardLinksHeight);
                        }
                    });
                    else $.each(cards, function(index, element) {
                        if ($(element).hasClass('card--even')) {
                            // Find Next 'Odd' card down
                            var nextCard = $(element).next('.card--odd');
                            // Reset any inline CSS
                            $(nextCard[0]).find('h3').css("height", '');
                            $(nextCard[0]).find('.card__content').css("height", '');
                            $(nextCard[0]).find('.card__links').css("height", '');
                            $(element).find('h3').css("height", '');
                            $(element).find('.card__content').css("height", '');
                            $(element).find('.card__links').css("height", '');
                        }
                    });
                }
                // On Document Load
                $(document).ready(function() {
                    // Update Float Container
                    updateFloatContainers();
                    // Check Cards Heading
                    updateCardHeadings();
                    // Update Hidden Field on Application Form
                    $('#input_7_136').on('change', function() {
                        var value = this.value;
                        var text = this.options[this.selectedIndex].text;
                        $('#input_7_114 option').each(function() {
                            if ($(this).text() == text) $(this).prop("selected", "selected");
                        });
                    });
                    // Update Donate Form Custom Field Locations
                    $('#give-form-2906-wrap #give_checkout_user_info').append($('#give-form-2906-wrap #contact_number-wrap'));
                    $('#give-form-2906-wrap #give_checkout_user_info').append($('#give-form-2906-wrap #give-gift-aid-address-fields-2906'));
                    $('#give-form-2906-wrap #give-gift-aid-dedicate-donation-2906').prepend($('#give-form-2906-wrap #gift_aid_title-wrap'));
                    $('#give-form-2906-wrap #give-gift-aid-dedicate-donation-2906').prepend($('#give-form-2906-wrap #contact_preferences_2_donate-wrap'));
                    $('#give-form-2906-wrap #give-gift-aid-dedicate-donation-2906').prepend($('#give-form-2906-wrap #contact_preferences_1_donate-wrap'));
                    $('#give-form-2906-wrap #give-gift-aid-dedicate-donation-2906').prepend($('#give-form-2906-wrap #gift_aid_1-wrap'));
                    // Update Join the Friends Form Custom Field Locations
                    $('#give-form-3442-wrap #give_checkout_user_info').append($('#give-form-3442-wrap #contact_number-wrap'));
                    $('#give-form-3442-wrap #give_checkout_user_info').append($('#give-form-3442-wrap #give-gift-aid-address-fields-3442'));
                    $('#give-form-3442-wrap #give-gift-aid-dedicate-donation-3442').prepend($('#give-form-3442-wrap #contact_preferences_2_1-wrap'));
                    $('#give-form-3442-wrap #give-gift-aid-dedicate-donation-3442').prepend($('#give-form-3442-wrap #contact_preferences_2_friends-wrap'));
                    $('#give-form-3442-wrap #give-gift-aid-dedicate-donation-3442').prepend($('#give-form-3442-wrap #contact_preferences_1_friends-wrap'));
                    $('#give-form-3442-wrap #give-gift-aid-dedicate-donation-3442').prepend($('#give-form-3442-wrap #contact_1-wrap'));
                    // Form Loaded and Animate in
                    setTimeout(function() {
                        $('.donate-main__form').addClass('donate-main__form--loaded');
                    }, 1000);
                });
                // On Window Resize
                $(window).resize(function() {
                    // Update Float Containers
                    updateFloatContainers();
                    // Check Cards Heading
                    updateCardHeadings();
                    // Reset Nav
                    var width = $(document).width();
                    if (width < 900) $('body, .nav-mobile, .mobile-trigger span').removeClass('mobile-menu-active');
                });
                // Course Nav Mobile
                $('.course-nav').click(function() {
                    var windowWidth = $(document).width();
                    if (windowWidth <= 767) {
                        if ($('.course-nav').hasClass('mobile-close')) {
                            $('.course-nav').removeClass('mobile-close');
                            $('.course-nav').addClass('mobile-open');
                        } else {
                            $('.course-nav').removeClass('mobile-open');
                            $('.course-nav').addClass('mobile-close');
                        }
                    }
                });
                $('.course-nav__nav a').click(function() {
                    var windowWidth = $(document).width();
                    if (windowWidth <= 767) {
                        $('.course-nav').removeClass('mobile-open');
                        $('.course-nav').addClass('mobile-close');
                    }
                });
                // Donate
                $('.donate-main__select-select').click(function() {
                    $('.donate-main__select-select').removeClass('active');
                    $(this).addClass('active');
                    var form = $(this).data('form');
                    $('.donate-main__form').removeClass('active');
                    $('.donate-main__form-' + form).addClass('active');
                });
                // Maps
                $('.map__select-option').click(function() {
                    var id = $(this).data('id');
                    $('.map__select-option').removeClass('active');
                    $(this).addClass('active');
                    $('.map__tabs-tab').removeClass('active');
                    $('.map__tabs-tab--' + id).addClass('active');
                });
                // Table Accordion
                $('.table__intro').click(function() {
                    if ($(this).closest('.block__table').hasClass('open')) $(this).closest('.block__table').removeClass('open');
                    else {
                        $('.block__table').removeClass('open');
                        $(this).closest('.block__table').addClass('open');
                    }
                });
                // Testimonials
                $('.testimonial-select').click(function() {
                    if ($(this).hasClass('active')) return;
                    else {
                        var selectID = $(this).data('select');
                        $('.testimonial-select').removeClass('active');
                        $(this).addClass('active');
                        $('.testimonial-image').removeClass('active');
                        $('.testimonial-image-' + selectID).addClass('active');
                        $('.testimonial-bio').removeClass('active');
                        $('.testimonial-bio-' + selectID).addClass('active');
                        $('.testimonial-testimonial').removeClass('active');
                        $('.testimonial-testimonial-' + selectID).addClass('active');
                    }
                });
                /*
				 *
				 * Sliders
				 *
				 */ // Hero Slider
                $('.hero__content-slider').slick({
                    dots: false,
                    arrows: true,
                    draggable: false,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    fade: true
                });
                $('.hero__slick-slider').slick({
                    dots: false,
                    arrows: true,
                    draggable: false,
                    slidesToShow: 1,
                    fade: true
                });
                $('.hero-slider-controls-prev').click(function() {
                    $('.hero__content-slider').slick('slickPrev');
                    $('.hero__slick-slider').slick('slickPrev');
                });
                $('.hero-slider-controls-next').click(function() {
                    $('.hero__content-slider').slick('slickNext');
                    $('.hero__slick-slider').slick('slickNext');
                });
                // Image Gallery Slider
                $('.image-gallery__gallery').slick({
                    dots: false,
                    arrows: true,
                    slidesToShow: 2.5,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                // Course Details Slider
                $('.lower-slider__slider').slick({
                    dots: false,
                    arrows: true,
                    fade: true,
                    draggable: false,
                    slidesToShow: 1,
                    prevArrow: $('.lower-slider__controls-prev'),
                    nextArrow: $('.lower-slider__controls-next')
                });
                // Content Slider
                $('.content-slider__left-slider').slick({
                    dots: false,
                    arrows: true,
                    fade: true,
                    slidesToShow: 1,
                    draggable: false,
                    adaptiveHeight: false,
                    responsive: [
                        {
                            breakpoint: 999,
                            settings: {
                                adaptiveHeight: true
                            }
                        }
                    ]
                });
                $('.content-slider__right').slick({
                    dots: false,
                    arrows: true,
                    draggable: false,
                    slidesToShow: 1,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                // Cards Slider
                $('.cards-grid__slider--col-2').slick({
                    dots: false,
                    arrows: true,
                    slidesToShow: 2,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                $('.cards-grid__slider--col-3').slick({
                    dots: false,
                    arrows: true,
                    slidesToShow: 3,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                // Custom Controls for Slick Sliders
                $('.left-controls__previous').click(function() {
                    $('.content-slider__left-slider').slick('slickPrev');
                    $('.content-slider__right').slick('slickPrev');
                    $('.image-gallery__gallery').slick('slickPrev');
                });
                $('.left-controls__next').click(function() {
                    $('.content-slider__left-slider').slick('slickNext');
                    $('.content-slider__right').slick('slickNext');
                    $('.image-gallery__gallery').slick('slickNext');
                });
                $('.cards-grid__previous').click(function() {
                    $('.cards-grid__slider--col-2').slick('slickPrev');
                    $('.cards-grid__slider--col-3').slick('slickPrev');
                });
                $('.cards-grid__next').click(function() {
                    $('.cards-grid__slider--col-2').slick('slickNext');
                    $('.cards-grid__slider--col-3').slick('slickNext');
                });
                if ('IntersectionObserver' in window) {
                    /*
					 *	Blocks Intersection Observer
					 */ // Intersection Observer Callback Function
                    blockObserverCallback = function(entries, observer) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                entry.target.classList.add('in-view');
                                observer.unobserve(entry.target);
                            }
                        });
                    };
                    // Intersection Observer Options
                    var blockObserverOptions = {
                        root: null,
                        rootMargin: '0% 0% -30% 0%',
                        threshold: 0
                    };
                    // Creation of Intersection Observer
                    var blockObserver = new IntersectionObserver(blockObserverCallback, blockObserverOptions);
                    // Intersection Observer Elements to observe
                    blockObserverElements = document.querySelectorAll('.block');
                    // Pass Elements to Observer
                    blockObserverElements.forEach(function(blockObserverElement) {
                        blockObserver.observe(blockObserverElement);
                    });
                    /*
					 *	Course Nav Intersection Observer
					 */ // Intersection Observer Callback Function
                    courseNavObserverCallback = function(entries, observer) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                sectionId = entry.target.id;
                                if (!sectionId) ;
                                else {
                                    var navItem = $('.nav-id-' + sectionId).text();
                                    $('.course-nav-overview').text(navItem);
                                    $('.course-nav-item').removeClass('active');
                                    $('.nav-id-' + sectionId).addClass('active');
                                }
                            }
                        });
                    };
                    // Intersection Observer Options
                    var courseNavObserverOptions = {
                        root: null,
                        rootMargin: '-20% 0% -70% 0%',
                        threshold: 0
                    };
                    // Creation of Intersection Observer
                    var courseNavObserver = new IntersectionObserver(courseNavObserverCallback, courseNavObserverOptions);
                    // Intersection Observer Elements to observe
                    courseNavObserverElements = document.querySelectorAll('.block');
                    // Pass Elements to Observer
                    courseNavObserverElements.forEach(function(courseNavObserverElement) {
                        courseNavObserver.observe(courseNavObserverElement);
                    });
                } else {
                    /*
					 *	Blocks Intersection Observer Fallback
					 */ blockObserverElements = document.querySelectorAll('.block');
                    blockObserverElements.forEach(function(blockObserverElement) {
                        blockObserverElement.classList.add('in-view');
                    });
                }
                // Accordions
                $('.toggle').click(function(e) {
                    e.preventDefault();
                    var $this = $(this);
                    if ($this.next().hasClass('show')) {
                        $this.next().removeClass('show');
                        $this.removeClass('active');
                        $this.next().slideUp(350);
                    } else {
                        $this.parent().parent().find('li .inner').removeClass('show');
                        $this.parent().parent().find('li .inner').slideUp(350);
                        $this.next().toggleClass('show');
                        $this.addClass('active');
                        $this.next().slideToggle(350);
                    }
                });
                // Google Map
                function new_map($el) {
                    // var
                    var $markers = $el.find('.marker');
                    // vars
                    var args = {
                        zoom: 16,
                        center: new google.maps.LatLng(0, 0),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        scrollwheel: false,
                        navigationControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        draggable: false
                    };
                    // create map
                    var map = new google.maps.Map($el[0], args);
                    // add a markers reference
                    map.markers = [];
                    // add markers
                    $markers.each(function() {
                        add_marker($(this), map);
                    });
                    // center map
                    center_map(map);
                    // return
                    return map;
                }
                function add_marker($marker, map) {
                    // var
                    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
                    var icon = $marker.attr('data-icon');
                    // create marker
                    var marker = new google.maps.Marker({
                        position: latlng,
                        map: map,
                        icon: icon
                    });
                    // add to array
                    map.markers.push(marker);
                    // if marker contains HTML, add it to an infoWindow
                    if ($marker.html()) {
                        // create info window
                        var infowindow = new google.maps.InfoWindow({
                            content: $marker.html()
                        });
                        // show info window when marker is clicked
                        google.maps.event.addListener(marker, 'click', function() {
                            infowindow.open(map, marker);
                        });
                    }
                }
                function center_map(map) {
                    // vars
                    var bounds = new google.maps.LatLngBounds();
                    // loop through all markers and create bounds
                    $.each(map.markers, function(i, marker) {
                        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                        bounds.extend(latlng);
                    });
                    // only 1 marker?
                    if (map.markers.length == 1) {
                        // set center of map
                        map.setCenter(bounds.getCenter());
                        map.setZoom(16);
                    } else // fit to bounds
                    map.fitBounds(bounds);
                }
                // global var
                var map = null;
                $('.acf-map').each(function() {
                    // create map
                    map = new_map($(this));
                });
            },
            finalize: function() {
            // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        home: {
            init: function() {
            // JavaScript to be fired on the home page
            },
            finalize: function() {
            // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        about_us: {
            init: function() {
            // JavaScript to be fired on the about us page
            }
        },
        contact: {
            init: function() {}
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = mirai;
            funcname = funcname === undefined ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) namespace[func][funcname](args);
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

})();
//# sourceMappingURL=app.js.map
